export default __webpack_public_path__ + "square-shape-shadow.png";